// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
    background-color: var(--bg-card);
    min-width: 240px;
    max-width: 240px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 24px 16px;
    height: 100vh;
    overflow: hidden;
    border-right: 1px solid var(--border);
}

.sidebar_logo {
    max-width: 100%;
    padding: 0 8px;
    margin-bottom: 8px;
}

.sidebar_menu {
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: 100%;
    flex: 1 1;
    overflow-y: auto;
    padding: 0 4px;
}

.sidebar_item_link {
    text-decoration: none;
    color: inherit;
}

.sidebar_item {
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 12px;
    max-width: 100%;
    padding: 10px 12px;
    border-radius: var(--radius-sm);
    position: relative;
    transition: all var(--transition-fast);
    color: var(--text-secondary);
}

.sidebar_item_col {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: start;
    max-width: 100%;
    padding: 10px 12px;
    border-radius: var(--radius-sm);
    position: relative;
    transition: all var(--transition-fast);
    color: var(--text-secondary);
}

.sidebar_item_col:hover .sidebar_item_notselected {
    background-color: var(--bg);
}

.sidebar_item_link:hover .sidebar_item_notselected {
    background-color: var(--bg);
}

.sidebar_item_childtop {
    font-size: 14px;
    display: flex;
    gap: 12px;
    max-width: 100%;
    align-items: center;
}

.sidebar_item_childbottom {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    margin-left: 16px;
    font-size: 13px;
    max-height: 0;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
    gap: 2px;
}

.sidebar_item_childbottom-transition {
    margin-top: 12px;
    max-height: 500px;
}

.sidebar-info {
    width: 3px;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    border-radius: 3px;
}

.sidebar-subitem_info {
    width: 8px;
    height: 8px;
    position: absolute;
    left: 0px;
    top: 4px;
    border-radius: 4px;
}

.sidebar_item_selected {
    background-color: var(--primary-light);
}

.sidebar_item_selected .sidebar_item_name {
    font-weight: 600;
    color: var(--primary);
}

.sidebar_item_selected .sidebar_item_icon {
    filter: brightness(0) saturate(100%) invert(26%) sepia(94%) saturate(4013%) hue-rotate(237deg) brightness(91%) contrast(96%);
}

.sidebar_item_notselected {
    background-color: transparent;
}

.sidebar_subitem_selected {
    background-color: var(--primary-light);
}

.sidebar_subitem_notselected {
    background-color: transparent;
}

.sidebar_subitem_notselected:hover {
    background-color: var(--bg);
}

.sidebar_subitem_link {
    text-decoration: none;
    color: inherit;
    position: relative;
    padding: 6px 12px 6px 20px;
    border-radius: var(--radius-sm);
    display: block;
    transition: all var(--transition-fast);
}

.sidebar_subitem_link:hover {
    background-color: var(--bg);
}

.sidebar_item_icon {
    width: 18px;
    opacity: 0.7;
    transition: all var(--transition-fast);
}

.sidebar_item_name {
    margin: 0;
    font-weight: 400;
    transition: color var(--transition-fast);
}

.iconClose {
    transform: rotate(0);
    transition: transform var(--transition-normal);
    width: 12px;
}

.iconOpen {
    transform: rotate(180deg);
    transition: transform var(--transition-normal);
    width: 12px;
}

[data-theme="dark"] .iconClose,
[data-theme="dark"] .iconOpen {
    filter: invert(1);
}

[data-theme="dark"] .sidebar_item_icon {
    filter: invert(0.8);
}

/* Profile section */
.sidebar_profil {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 16px 8px 0;
    border-top: 1px solid var(--border);
    margin-top: 12px;
}

.sidebar_profil_link {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: inherit;
    gap: 10px;
    transition: opacity var(--transition-fast);
}

.sidebar_profil_link:hover {
    opacity: 0.8;
}

.sidebar_profil_picture {
    width: 34px;
    height: 34px;
}

.sidebar_profil_img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
}

.sidebar_profil_img_active {
    box-sizing: border-box;
    box-shadow: 0 0 0 2px var(--primary);
}

.sidebar_profil_infos {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.sidebar_profil_name {
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    color: var(--text-primary);
}

.sidebar_profil_role {
    margin: 0;
    font-size: 11px;
    color: var(--text-muted);
}

.sidebar_profil_logout {
    cursor: pointer;
    padding: 6px;
    border-radius: var(--radius-sm);
    transition: background-color var(--transition-fast);
    opacity: 0.6;
}

.sidebar_profil_logout:hover {
    background-color: var(--danger-light);
    opacity: 1;
}

@media (max-width: 768px) {
    .sidebar {
        display: none;
    }
}

@media (max-height: 900px) {
    .sidebar {
        justify-content: flex-start;
        gap: 24px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/menu/sidebar/sidebar.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;IACX,SAAO;IACP,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,sCAAsC;IACtC,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,sCAAsC;IACtC,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,gCAAgC;IAChC,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,4HAA4H;AAChI;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,0BAA0B;IAC1B,+BAA+B;IAC/B,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,oBAAoB;IACpB,8CAA8C;IAC9C,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,8CAA8C;IAC9C,WAAW;AACf;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;IACnB,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,SAAS;IACT,0CAA0C;AAC9C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;AACV;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,+BAA+B;IAC/B,mDAAmD;IACnD,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,UAAU;AACd;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,SAAS;IACb;AACJ","sourcesContent":[".sidebar {\n    background-color: var(--bg-card);\n    min-width: 240px;\n    max-width: 240px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    padding: 24px 16px;\n    height: 100vh;\n    overflow: hidden;\n    border-right: 1px solid var(--border);\n}\n\n.sidebar_logo {\n    max-width: 100%;\n    padding: 0 8px;\n    margin-bottom: 8px;\n}\n\n.sidebar_menu {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    width: 100%;\n    flex: 1;\n    overflow-y: auto;\n    padding: 0 4px;\n}\n\n.sidebar_item_link {\n    text-decoration: none;\n    color: inherit;\n}\n\n.sidebar_item {\n    font-size: 14px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    max-width: 100%;\n    padding: 10px 12px;\n    border-radius: var(--radius-sm);\n    position: relative;\n    transition: all var(--transition-fast);\n    color: var(--text-secondary);\n}\n\n.sidebar_item_col {\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    max-width: 100%;\n    padding: 10px 12px;\n    border-radius: var(--radius-sm);\n    position: relative;\n    transition: all var(--transition-fast);\n    color: var(--text-secondary);\n}\n\n.sidebar_item_col:hover .sidebar_item_notselected {\n    background-color: var(--bg);\n}\n\n.sidebar_item_link:hover .sidebar_item_notselected {\n    background-color: var(--bg);\n}\n\n.sidebar_item_childtop {\n    font-size: 14px;\n    display: flex;\n    gap: 12px;\n    max-width: 100%;\n    align-items: center;\n}\n\n.sidebar_item_childbottom {\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    margin-left: 16px;\n    font-size: 13px;\n    max-height: 0;\n    overflow: hidden;\n    transition: all 0.3s ease-in-out;\n    gap: 2px;\n}\n\n.sidebar_item_childbottom-transition {\n    margin-top: 12px;\n    max-height: 500px;\n}\n\n.sidebar-info {\n    width: 3px;\n    height: 100%;\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    border-radius: 3px;\n}\n\n.sidebar-subitem_info {\n    width: 8px;\n    height: 8px;\n    position: absolute;\n    left: 0px;\n    top: 4px;\n    border-radius: 4px;\n}\n\n.sidebar_item_selected {\n    background-color: var(--primary-light);\n}\n\n.sidebar_item_selected .sidebar_item_name {\n    font-weight: 600;\n    color: var(--primary);\n}\n\n.sidebar_item_selected .sidebar_item_icon {\n    filter: brightness(0) saturate(100%) invert(26%) sepia(94%) saturate(4013%) hue-rotate(237deg) brightness(91%) contrast(96%);\n}\n\n.sidebar_item_notselected {\n    background-color: transparent;\n}\n\n.sidebar_subitem_selected {\n    background-color: var(--primary-light);\n}\n\n.sidebar_subitem_notselected {\n    background-color: transparent;\n}\n\n.sidebar_subitem_notselected:hover {\n    background-color: var(--bg);\n}\n\n.sidebar_subitem_link {\n    text-decoration: none;\n    color: inherit;\n    position: relative;\n    padding: 6px 12px 6px 20px;\n    border-radius: var(--radius-sm);\n    display: block;\n    transition: all var(--transition-fast);\n}\n\n.sidebar_subitem_link:hover {\n    background-color: var(--bg);\n}\n\n.sidebar_item_icon {\n    width: 18px;\n    opacity: 0.7;\n    transition: all var(--transition-fast);\n}\n\n.sidebar_item_name {\n    margin: 0;\n    font-weight: 400;\n    transition: color var(--transition-fast);\n}\n\n.iconClose {\n    transform: rotate(0);\n    transition: transform var(--transition-normal);\n    width: 12px;\n}\n\n.iconOpen {\n    transform: rotate(180deg);\n    transition: transform var(--transition-normal);\n    width: 12px;\n}\n\n[data-theme=\"dark\"] .iconClose,\n[data-theme=\"dark\"] .iconOpen {\n    filter: invert(1);\n}\n\n[data-theme=\"dark\"] .sidebar_item_icon {\n    filter: invert(0.8);\n}\n\n/* Profile section */\n.sidebar_profil {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding: 16px 8px 0;\n    border-top: 1px solid var(--border);\n    margin-top: 12px;\n}\n\n.sidebar_profil_link {\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    color: inherit;\n    gap: 10px;\n    transition: opacity var(--transition-fast);\n}\n\n.sidebar_profil_link:hover {\n    opacity: 0.8;\n}\n\n.sidebar_profil_picture {\n    width: 34px;\n    height: 34px;\n}\n\n.sidebar_profil_img {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.sidebar_profil_img_active {\n    box-sizing: border-box;\n    box-shadow: 0 0 0 2px var(--primary);\n}\n\n.sidebar_profil_infos {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n}\n\n.sidebar_profil_name {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--text-primary);\n}\n\n.sidebar_profil_role {\n    margin: 0;\n    font-size: 11px;\n    color: var(--text-muted);\n}\n\n.sidebar_profil_logout {\n    cursor: pointer;\n    padding: 6px;\n    border-radius: var(--radius-sm);\n    transition: background-color var(--transition-fast);\n    opacity: 0.6;\n}\n\n.sidebar_profil_logout:hover {\n    background-color: var(--danger-light);\n    opacity: 1;\n}\n\n@media (max-width: 768px) {\n    .sidebar {\n        display: none;\n    }\n}\n\n@media (max-height: 900px) {\n    .sidebar {\n        justify-content: flex-start;\n        gap: 24px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
